import React from 'react'
import Logo from '../../img/LYNX.png';

const Home = () => {
    return (
        <div>
            <div className="d-flex justify-content-center align-items-center flex-column">
            <img src={Logo} alt="team-logo"  data-aos="fade-down" className="pb-3" />
            <i class="fas fa-chevron-down"></i>
            </div>
        </div>
    )
}

export default Home
